
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.23 16.62h9.16M9.22 10.38v6.24l-5.52 7v15.03h23.55v-5.06c0-7-3.16-8.85-5.69-12s-3.17-3.79-3.17-7v-4.4M22.24 8.92a5.7 5.7 0 005.69 5.7M3.53 26.63h22.14"}}),_c('circle',{attrs:{"cx":"32.04","cy":"4.88","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"37.47","cy":"1.85","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"37.47","cy":"7.91","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M26.3 2.68H8.89l-6.36 7.7h15.73l8.04-3.35V2.68z"}})])
          )
        }
      }
    